import MystarInvoiceList from './InvoiceList';
import MystarInvoiceShow from './InvoiceShow';

export default {
    list: MystarInvoiceList,
    // show: MystarInvoiceShow
};
